import { ChevronLeft, ChevronRight } from "lucide-react";

export function Pagination({ page, pageSize, total, onPage }: { page: number; pageSize: number; total: number; onPage: (page: number) => void }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  return (
    <footer className="pagination">
      <span>{total === 0 ? "0 records" : `${(page - 1) * pageSize + 1}–${Math.min(page * pageSize, total)} of ${total}`}</span>
      <div>
        <button className="icon-button" type="button" onClick={() => onPage(page - 1)} disabled={page <= 1} title="Previous page"><ChevronLeft size={18} /></button>
        <span>Page {page} of {totalPages}</span>
        <button className="icon-button" type="button" onClick={() => onPage(page + 1)} disabled={page >= totalPages} title="Next page"><ChevronRight size={18} /></button>
      </div>
    </footer>
  );
}
